"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _HousesFilters = require("./HousesFilters");
Object.keys(_HousesFilters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HousesFilters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _HousesFilters[key];
    }
  });
});